// Module
var code = "<!-- ko with: _colorModel --> <!-- ko template: {html: $data.GetTemplate.bind($data)} --><!-- /ko --> <!-- /ko -->";
// Exports
export default code;